import classNames from 'clsx'
import { arrayOf, bool, func, oneOfType, shape, string } from 'prop-types'
import { forwardRef } from 'react'

import { isMobile } from 'shared/utils/deviceClassUtils'
import noop from 'shared/utils/noop'
import OffCanvasEntryView from 'views/components/organisms/OffCanvas/OffCanvasEntryView'
import OffCanvasView from 'views/components/organisms/OffCanvas/OffCanvasView'
import { offCanvasCategory, shopLanguagesType } from 'views/utils/propTypes'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import './OffCanvas.scss'

const OffCanvas = forwardRef(function OffCanvas(props, ref) {
  const {
    visibleStack,
    hidden,
    goBackHandler,
    closeMenuHandler,
    goNextHandler,
    language,
    userData,
  } = props

  const { deviceClass } = usePublicConfig()
  const navClass = classNames('u-hidden@print o-OffCanvas', {
    'u-hidden@medium': !isMobile(deviceClass),
  })

  return (
    <nav
      id="OffCanvasMenu"
      className={navClass}
      aria-hidden={hidden ? true : null}
      aria-labelledby="OffCanvasMenuHeader"
      data-clientside-hook="menu"
      ref={ref}
    >
      {visibleStack.map((view, i) => {
        const commonProps = {
          key: `${view.id}-${i}`,
          data: view,
          closeMenuHandler,
          goNextHandler,
        }
        const offCanvasEntryViewProps = {
          ...commonProps,
          language,
          userData,
        }
        const offCanvasEntryProps = {
          ...commonProps,
          goBackHandler,
        }
        const showEntry = i === 0
        return showEntry ? (
          <OffCanvasEntryView {...offCanvasEntryViewProps} />
        ) : (
          <OffCanvasView {...offCanvasEntryProps} />
        )
      })}
    </nav>
  )
})

OffCanvas.propTypes = {
  visibleStack: arrayOf(offCanvasCategory).isRequired,
  userData: shape({}),
  language: oneOfType([string, shopLanguagesType]),
  hidden: bool,
  goBackHandler: func,
  closeMenuHandler: func,
  goNextHandler: func,
}

OffCanvas.defaultProps = {
  userData: null,
  language: null,
  hidden: false,
  goBackHandler: noop,
  closeMenuHandler: noop,
  goNextHandler: () => noop,
}

export default OffCanvas
